
import MinMaxSelect from '@/ui-kit/components/min-max-select';
import MinMaxEvents from '../mixins/MinMaxEvents';
import RangeCommonProps from '../mixins/RangeCommonProps';
import { YEAR_BUILT_OPTIONS } from '../constants/options';

export default {
  name: 'FilterRangeYearBuilt',
  components: {
    MinMaxSelect,
  },
  mixins: [MinMaxEvents, RangeCommonProps],
  props: {
    label: {
      default: 'Year Built',
      type: String,
    },
    minValues: {
      default: () => YEAR_BUILT_OPTIONS,
      type: Array,
    },
    maxValues: {
      default: () => YEAR_BUILT_OPTIONS,
      type: Array,
    },
  },
};
